<section class="container-xxl">
  <div *ngIf="anchor" [mbScrollSpy]="anchor"></div>
  <mb-info [type]="infoType">
    <div class="magazine-info-content-wrapper">
      <h3 *ngIf="headline" class="h4 mb-info-heading-cs">
        <i *ngIf="config.iconClass" class="mb-icon {{ config.iconClass }}"></i>
        <span>{{ headline | translate }}</span>
      </h3>
      <p class="copy-xl" *ngIf="text">{{ text | translate }}</p>
      <ng-container *ngIf="buttonLabel">
        <ng-container [ngSwitch]="linkType">
          <ng-container *ngSwitchCase="'external'">
            <a class="btn {{ config.buttonClass }}" [href]="buttonLink" target="_{{ buttonTargetType }}">
              {{ buttonLabel }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="'internal'">
            <a class="btn {{ config.buttonClass }}" [routerLink]="buttonLink">
              {{ buttonLabel }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="'modal'">
            <button class="btn {{ config.buttonClass }}" (click)="openQaForm()">
              {{ buttonLabel }}
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </mb-info>
</section>
